export default __webpack_public_path__ + "static/media/banner.1dece931.jpg";